'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PublicSharingLink = require('./PublicSharingLink.js');

var _PublicSharingLink2 = _interopRequireDefault(_PublicSharingLink);

var _Button = require('../../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _boardSharingHelpers = require('../boardSharingHelpers');

require('./BoardSharingPublic.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoardSharingPublic = function BoardSharingPublic(props) {
    var boardPermissions = props.boardPermissions,
        publiclyShareBoard = props.publiclyShareBoard;


    var linkElement = _react2.default.createElement(
        _Button2.default,
        { className: 'link-button', onClickFn: publiclyShareBoard },
        'Create a secret link to view this board'
    );

    if ((0, _boardSharingHelpers.isPublic)(boardPermissions)) {
        linkElement = _react2.default.createElement(_PublicSharingLink2.default, props);
    }

    return _react2.default.createElement(
        'div',
        { className: 'BoardSharingPublic' },
        linkElement,
        _react2.default.createElement(
            'p',
            { className: 'link-explain' },
            _react2.default.createElement(
                'strong',
                null,
                'Anyone'
            ),
            ' with this link will be able to view (but not edit) this board'
        )
    );
};

BoardSharingPublic.propTypes = {
    boardPermissions: _propTypes2.default.object,
    currentBoardId: _propTypes2.default.string,
    publiclyShareBoard: _propTypes2.default.func
};

exports.default = BoardSharingPublic;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/publicLink/BoardSharingPublic.js
// module id = 2194
// module chunks = 0